var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('app-head',{attrs:{"title":_vm.page.meta_title || _vm.page.title}},[(_vm.page.meta_description)?_c('meta',{attrs:{"name":"description","content":_vm.page.meta_description}}):_vm._e()]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }